import React from 'react';
import { Container } from '@mui/material';
import InterventionStrategyGenerator from '../components/InterventionStrategyGenerator';

const InterventionStrategyGeneratorPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <InterventionStrategyGenerator />
    </Container>
  );
};

export default InterventionStrategyGeneratorPage;